export const DEFAULT_AVATAR = "/assets/avatar.png";

/** Strips a dev-only "/src" prefix some stored avatar paths still carry. */
export const removeSrc = (url: string): string => {
  if (!url) return url;
  return url.startsWith("/src") ? url.substring(4) : url;
};

/** The URL to render for a user's avatar, falling back to the default image
 * for missing values (including the literal string "undefined" that older
 * clients persisted). */
export const resolveAvatar = (url?: string | null, fallback: string = DEFAULT_AVATAR): string => {
  const cleaned = removeSrc(url || "");
  return !cleaned || cleaned === "undefined" ? removeSrc(fallback) : cleaned;
};
